class ReviverError extends Error {}

const parseJSON = (text, reviver, { logError = false } = {}) => {
  const reviverWithErrorForwarding = typeof reviver == 'function' && ((...args) => {
    try {
      return reviver(...args)
    } catch (cause) {
      throw new ReviverError('', { cause })
    }
  })

  try {
    return JSON.parse(text, reviverWithErrorForwarding)
  } catch (error) {
    if (error instanceof ReviverError) throw error.cause
    if (logError) console.error(error)
  }
}

export default parseJSON
